import { render, staticRenderFns } from "./gradeItem.vue?vue&type=template&id=dab95af0&scoped=true&"
import script from "./gradeItem.vue?vue&type=script&lang=js&"
export * from "./gradeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab95af0",
  null
  
)

export default component.exports